require('select2/dist/js/select2.full.js');
require('backbone.stickit');
require('backbone.marionette');
require('select2/src/scss/core.scss');
require('./dropdown-list.scss');
Backbone.Stickit.addHandler({
    selector: 'select.select2',
    initialize: function($el, model, opt) {
        var e = 'change:' + opt.observe, self = this;
        function formatState (state) {
            if (!state.id) {
                return state.text;
            }
            if (self.options.formatResult) {
                return self.options.formatResult(
                    self._getModelByValueAttrValue(state.element.value)
                );
            }
            return state.text;
        }

        $el.select2({
            dropdownCssClass: 'tl-dropdown-list-select2-container ' + this.options.dropdownCssClass,
            minimumResultsForSearch:
                this.options.suppressSearch ?
                Infinity :
                this.options.minimumResultsForSearch,
            placeholder: this.options.placeholder,
            allowClear: this.options.allowClear,
            width: this.options.width,
            dropdownAutoWidth: 'true',
            disabled: this.options.disabled,
            templateResult: formatState,
            dropdownParent: this.options.dropdownParent
        });
        var up = function(m, v, o) {
            if (!o.stickitChange) {
                $el.trigger('change');
            }
        };
        this.listenTo(model, e, up);
        this.listenTo(model, 'stickit:unstuck', function() {
            self.stopListening(model, e, up);
        });
    }
});

var DropdownList = Marionette.ItemView.extend({
    template: require('./dropdown-list.tpl'),
    className: 'tl-dropdown-list',
    ui: {
        select: 'select'
    },
    bindings: function () {
        var bindings = {};
        bindings.select = {};
        bindings.select.observe = this.options.modelAttr;
        bindings.select.setOptions = {
            validate: this.options.validateOnSet
        };
        bindings.select.selectOptions = {
            collection: this.collection,
            labelPath: this.options.displayAttr,
            valuePath: this.options.valueAttr
        };
        if (this.options.placeholder) {
            bindings.select.selectOptions =
                _.extend(
                    bindings.select.selectOptions,
                    {
                        defaultOption: {
                            label: this.options.placeholder,
                            value: null
                        }
                    }
                );
        }
        return bindings;
    },
    events: {
        'select2:unselect': function () {
            if (this.options.multipleSelectionsAllowed) {
                this.trigger('selected', this.val());
                if (this.options.onSelectedCallback) {
                    this.options.onSelectedCallback(
                        this.val()
                    );
                }
            } else {
                this.trigger('selected', null);
                if (this.options.onSelectedCallback) {
                    this.options.onSelectedCallback(
                        null,
                        null
                    );
                }
            }
        },
        'select2:select select': function () {
            this.trigger('selected', this.val());
            if (this.options.multipleSelectionsAllowed) {
                if (this.options.onSelectedCallback) {
                    this.options.onSelectedCallback(
                        this.val()
                    );
                }
            } else {
                if (this.options.onSelectedCallback) {
                    this.options.onSelectedCallback(
                        this.val(),
                        this._getModelByValueAttrValue(this.val())
                    );
                }
            }
        },
        'select2:selecting': function (e) {
            var selectingValue = e.params.args.data.id;
            // preventSelection is a way for callers to prevent a selection
            // from being made but still react to it by listening to the
            // "clicked" event
            if (this.options.preventSelection &&
                this.options.preventSelection(selectingValue))
            {
                e.preventDefault();
                this.trigger('clicked', selectingValue);
                this.ui.select.select2('close');
            }
        }
    },
    _getModelByValueAttrValue: function (val) {
        var self = this;
        return _.find(self.collection, function (item) {
            return item[self.options.valueAttr] == val;
        });
    },
    val: function (val) {
        if (_.isUndefined(val)) {
            return this.ui.select.val();
        } else {
            this.ui.select.val(val).trigger('change');
        }
    },
    initialize: function (options) {
        var that = this;
        this.options = _.defaults(
            options || {},
            {
                customClassName: '',
                dropdownParent: null,
                dropdownCssClass: '',
                suppressSearch: false,
                minimumResultsForSearch: 5,
                placeholder: undefined,
                allowClear: false,
                preventSelection: null,
                width: undefined,
                modelAttr: 'dummy',
                displayAttr: undefined,
                valueAttr: undefined,
                disabled: false,
                initialValue: undefined,
                onSelectedCallback: undefined,
                validateOnSet: false,
                multipleSelectionsAllowed: false
            }
        );
        this.model = this.options.model || new Backbone.Model();
    },
    onDestroy: function () {
        if (this.ui.select.data('select2')) {
            this.ui.select.select2('destroy');
        }
        this.unstickit();
    },
    onShow: function () {
        if (this.options.initialValue) {
            this.val(this.options.initialValue);
        }
    },
    onRender: function () {
        var that = this;

        // Add a special class to the drop down list flyout if
        // this drop down list is a child of a modal to ensure
        // proper z-index.
        this.ui.select.on('select2:open', function () {
            if (that.$el.parents('.modal').length) {
                $('.select2-container.select2-container--open')
                    .addClass('modal-select2-container');
            }
        });

        this.$el.addClass(this.options.customClassName);

        this.stickit();
    },
    serializeData: function () {
        return {
            options: this.options
        };
    }
});
module.exports = DropdownList;



/*****************
 ** WEBPACK FOOTER
 ** ./assets/vendor/treeline-shared-components/dropdown-list/dropdown-list.js
 ** module id = 43
 ** module chunks = 1 2 3 4 5 6 7 8 10 11 12 13 17 18 19 20 21 22 24 25 26 31 34 35 36 37 41 43 47 52 63 65 72 73 74 75 90 93 102 131
 **/